import {
  ReportingGroupModel,
  IReportingGroupModel,
} from '@common/models/ReportingGroupModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class ReportingGroupService {
  private static baseUrl: string = '/api/reportinggroup';

  static tags = {
    upsertReportingGroup: 'upsertReportingGroup',
    deleteReportingGroup: 'deleteReportingGroup',
    getReportingGroups: 'getReportingGroups',
  };

  static getReportingGroups = (
    options?: ServiceMethodOptions,
  ): Promise<ReportingGroupModel[]> => {
    return trackPromise(
      new Promise<IReportingGroupModel[]>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .get<IReportingGroupModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess(
              'Medical History Categories fetched.',
              options,
            );
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to get Medical History Categories.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.getReportingGroups,
    );
  };
  static upsertReportingGroup = (
    data: IReportingGroupModel,
    options?: ServiceMethodOptions,
  ): Promise<ReportingGroupModel> => {
    return trackPromise(
      new Promise<IReportingGroupModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IReportingGroupModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess(
              'Medical History Category updated.',
              options,
            );
            resolve(new ReportingGroupModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to update Medical History Category.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.upsertReportingGroup,
    );
  };

  static deleteReportingGroup = (
    reportingGroupId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${reportingGroupId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Medical History Category has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to delete Medical History Category.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.deleteReportingGroup,
    );
  };
}
